import { useMutation } from 'react-query';
import { postEntityDraftLogo } from '../apis/PostEntityDraftLogo';

export const usePostEntityDraftLogo = () => useMutation(postEntityDraftLogo);
